<script>
    import { onMount } from 'svelte';
    import Chart from 'chart.js/auto';
    import chartService from '../../../services/chart.js';
    import dayjs from 'dayjs';
    import { format } from 'svelte-i18n';

    let {
        findingsCriticalData = [],
        findingsHighData = [],
        findingsMediumData = [],
        findingsLowData = [],
    } = $props();

    let canvas = $state();
    let chart;
    let today = dayjs();
    today     = today.format('YYYY-MM-DD');

    const removeLastIndex = (object) => {
        delete object[today]
        return object;
    }
    findingsCriticalData = removeLastIndex(findingsCriticalData);
    findingsHighData = removeLastIndex(findingsHighData);
    findingsMediumData = removeLastIndex(findingsMediumData);
    findingsLowData = removeLastIndex(findingsLowData);

    var config = {
        type: 'line',
        responsive: true,
        maintainAspectRatio: false,
        options: {
            plugins: {
                filler: {
                    //propagate: true
                },
                legend: {
                    position: 'top',
                    display : true,
                    labels:{
                        font: {family: 'Montserrat'}
                    }
                },
                title: {
                    display   : false,
                    text      : 'Cantidad máxima por día',
                    font: {family: 'Montserrat'}
                },
            },

            elements: {
                line: {
                    tension: 0.5,
                    fill: false,
                    borderWidth: 3,
                },
                point: {
                    // Elements options apply to all of the options unless overridden in a dataset
                    // In this case, we are setting the border of each horizontal bar to be 2px wide
                    pointRadius: 2,
                    hoverRadius: 3
                }
            },
            scales: {
                x: {
                    stacked: false,
                    ticks: {
                        type: "timeseries",
                        font: {
                            family: 'Montserrat'
                        }
                    }
                },
                y: {
                    stacked: false,
                    ticks: {
                        beginAtZero : true,
                    },
                    font: {
                        family: 'Montserrat'
                    }
                }
            }
        }
    };

    onMount(async () => {

        let labels   = Object.keys(findingsCriticalData);

        let datasets = [
            {
                label       : $format("vulnerability.severity.critical"),
                borderColor : chartService.colors.critical,
                pointBackgroundColor: chartService.colors.critical,
                data        : Object.values(findingsCriticalData)
            },
            {
                label       : $format("vulnerability.severity.high"),
                borderColor : chartService.colors.high,
                pointBackgroundColor: chartService.colors.high,
                data        : Object.values(findingsHighData)
            },
            {

                label       : $format("vulnerability.severity.medium"),
                borderColor : chartService.colors.medium,
                pointBackgroundColor: chartService.colors.medium,
                data        : Object.values(findingsMediumData)
            },
            {
                label       :$format("vulnerability.severity.low"),
                borderColor : chartService.colors.low,
                pointBackgroundColor: chartService.colors.low,
                data        : Object.values(findingsLowData)
            },
        ];

        config.data = {
            labels,
            datasets
        };

        let context = canvas.getContext('2d');
        chart   = new Chart(context, config);
    });
</script>

<canvas bind:this={canvas} id="chart-daily-max-count"></canvas>
